import { CertificateProgram, CertificateProgramEngagement } from '@mc/api'
import { isCertEligibleForSubscription } from 'pages/certificates/annualpass/subscriptionEligibility'
import { useIsEnterpriseMember } from 'pages/certificates/common'

// mccerts-2548_v1-subscriptions-entry-point: shared eligibility for the
// subscription entry-point experiment. Every surface (CM hero, sticky footer, …)
// must gate BOTH its render AND its exposure on this so excluded users never
// enter the experiment (SRM-safe).
//
// The experiment doesn't apply to:
// - certs excluded from the subscription offering (see isCertEligibleForSubscription)
// - painted-door pages (placeholder certs with no real product/offer — mccerts-2138)
// - coming-soon "notify me" (emailCapture)
// - pre-enrolled (notice) states
// - Enterprise users — checked here in addition to the GB "Enterprise
//   Membership Only" targeting rule, so force-enabling the flag (QA, URL
//   overrides) can't show purchase CTAs to enterprise members
//  - NVIDIA certificate
export const useIsSubscriptionsExpEligible = ({
  engagement,
  program,
  isPaintedDoor,
}: {
  engagement?: CertificateProgramEngagement
  program: CertificateProgram
  isPaintedDoor?: boolean
}): boolean => {
  const isEnterprise = useIsEnterpriseMember()
  const finalEngagement = engagement ?? program.defaultEngagement
  return (
    !isEnterprise &&
    isCertEligibleForSubscription(program.slug, isPaintedDoor) &&
    !(finalEngagement?.emailCapture || finalEngagement?.notice)
  )
}
